import { FC, useEffect, useState } from "react";
import { Link, useParams } from "react-router-dom";
import { useAppDispatch, useAppSelector } from "toolkit/hooks";
import { changeCurrentTab, changeDetaildeMode } from "toolkit/documents/categorization/categorization.slice";
import styles from "./Carousel.module.sass";
import cn from "classnames";
import {
	getDocumentList,
	getObjectListWithDocs,
	getObjectListWithModels,
} from "toolkit/documents/categorization/categorization.thunks";
import { ChangeSearchValue } from "toolkit/documents/documents.slice";

export const Carousel: FC = () => {
	const { organizationId, condition, folderId } = useParams();
	const { currentTab, detailedMode, versionMode } = useAppSelector((state) => state.categorization);
	const { searchValue } = useAppSelector((state) => state.documents);
	const [requestRequired, setRequestRequired] = useState<boolean>(false);
	const dispatch = useAppDispatch();

	useEffect(() => {
		// console.log("folderId", folderId);
		// console.log("currentTab", currentTab);

		if (folderId !== currentTab) dispatch(changeCurrentTab(String(folderId).toUpperCase()));
		//eslint-disable-next-line
	}, [folderId]);

	useEffect(() => {
		setRequestRequired(true);
	}, [currentTab, condition, detailedMode]);

	useEffect(() => {
		if (versionMode) return;
		if (requestRequired) {
			setRequestRequired(false);
			if (searchValue) dispatch(ChangeSearchValue(""));
			if (currentTab === "REGISTRY") {
				dispatch(getObjectListWithDocs({ organizationId: Number(organizationId) }));
			} else if (currentTab === "MODEL") {
				dispatch(getObjectListWithModels({ organizationId: Number(organizationId) }));
			} else
				dispatch(
					getDocumentList({
						organizationId: Number(organizationId),
						type: currentTab,
						archived: condition === "archive",
					}),
				);
		}
		//eslint-disable-next-line
	}, [requestRequired]);

	const list = [
		{ name: "Приказ о создании комиссии", id: "ORDER", archived: false },
		{ name: "Реестр бизнес-процессов", id: "PROCESS", archived: false },
		{ name: "Реестр объектов", id: "REGISTRY", archived: false },
		{ name: "Перечень и дополнения в перечень объектов КИИ", id: "ENUM", archived: true },
		{ name: "Модель угроз", id: "MODEL", archived: false },
		{ name: "Результаты присвоения категории значимости", id: "RESULT", archived: true },
		{ name: "Партии документов для ФСТЭК и ответное письмо от ФСТЭК", id: "BUNDLE", archived: false },
	];

	const currentTabHandler = () => {
		// if (tabId !== currentTab) dispatch(changeCurrentTab(tabId));
		if (detailedMode) dispatch(changeDetaildeMode(false));
	};

	return (
		<div data-comment-false={true} className={styles.carousel}>
			{(condition === "current" ? list : list.filter((item) => item.archived)).map((item) => (
				<Link
					to={`categorization/${item.id.toLowerCase()}`}
					key={item.id}
					replace={true}
					onClick={currentTabHandler}
					className={cn(styles.item, currentTab === item.id && styles["item-activated"])}>
					{item.name}
				</Link>
			))}
		</div>
	);
};
